import { Injectable } from '@angular/core';
import { EntityState, EntityStore, StoreConfig } from '@datorama/akita';
import { Transaction, TransactionType } from './transaction.model';

export interface TransactionRange {
  startDate: Date;
  endDate: Date;
}

export interface TransactionState extends EntityState<Transaction, string> {
  cachedDates: {
    [TransactionType.payment]: TransactionRange[];
    [TransactionType.ecash]: TransactionRange[];
    [TransactionType.loyalty]: TransactionRange[];
    [TransactionType.cardlink]: TransactionRange[];
  };
}

function createInitialState(): TransactionState {
  return {
    cachedDates: {
      [TransactionType.payment]: new Array<TransactionRange>(),
      [TransactionType.ecash]: new Array<TransactionRange>(),
      [TransactionType.loyalty]: new Array<TransactionRange>(),
      [TransactionType.cardlink]: new Array<TransactionRange>()
    }
  };
}

@Injectable({ providedIn: 'root' })
@StoreConfig({ name: 'transaction', idKey: 'TransactionRef' })
export class TransactionStore extends EntityStore<TransactionState> {
  constructor() {
    super(createInitialState());
  }
  addCachedDate(startDate: Date, endDate: Date, type: TransactionType) {
    let range = { startDate, endDate } as TransactionRange;

    this.update(x => {
      let state = {
        cachedDates: {
          [TransactionType.payment]: x.cachedDates[TransactionType.payment],
          [TransactionType.ecash]: x.cachedDates[TransactionType.ecash],
          [TransactionType.loyalty]: x.cachedDates[TransactionType.loyalty],
          [TransactionType.cardlink]: x.cachedDates[TransactionType.cardlink]
        }
      };
      state.cachedDates[type] = x.cachedDates[type].concat([range]);
      return x;
    });
  }
}
